import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AssessmentDetails } from "Assessments";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";

export default store => ({
  path: "timetable",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "timetable" */ "./components"),
        import(/* webpackChunkName: "timetable" */ "./modules/TimetableModule"),
        import(
          /* webpackChunkName: "timetable" */ "TimetableConfiguration/modules/TimetableConfigurationModule"
        ),
        import(
          /* webpackChunkName: "timetable" */ "AdminTimetable/modules/TimetableModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const timeTableReducer = importedModule2.default;
          const adminTimetableReducer = importedModule3.default;
          injectReducer(store, {
            key: "timetable",
            reducer,
          });
          injectReducer(store, {
            key: "timetableConfiguration",
            reducer: timeTableReducer,
          });
          injectReducer(store, {
            key: "timetableAdmin",
            reducer: adminTimetableReducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ClassRoomDetails(store), AssessmentDetails(store)],
});
